import { useEffect, useState } from 'react'
import { getTips, getWatchedTipsMap, putWatchedTipsMap, Tip } from './TipsService'
import { cloneDeep } from 'lodash'

/**
 *
 * @param blocks array of BLOCK enum values
 * @returns {{tips: Array<Tip>, unwatchedTipIndex: number | null, markAsWatched: Function}}
 */
export function useBlockTips(blocks) {
    const [watchedTipsMap, setWatchedTipsMap] = useState(() => getWatchedTipsMap())
    const [unwatchedTipIndex, setUnwatchedTipIndex] = useState(null)
    const [tips, setTips] = useState([])

    const markAsWatched = tipId => {
        let _watchedTipsMap = cloneDeep(watchedTipsMap)
        _watchedTipsMap[tipId] = true
        setWatchedTipsMap(_watchedTipsMap)
    }

    useEffect(() => putWatchedTipsMap(watchedTipsMap), [watchedTipsMap])

    useEffect(() => {
        const existsBlockTypes = new Set(blocks.map(block => block.t))
        const relevantTips = getTips(existsBlockTypes)
        let index = 0
        for (let tip of relevantTips) {
            if (watchedTipsMap[tip.id] !== true && existsBlockTypes.has(tip.blockType)) {
                setUnwatchedTipIndex(index)
                break
            }
            index++
        }
        setTips(relevantTips)
    }, [blocks])

    return { tips, unwatchedTipIndex, markAsWatched }
}
